const StatusEnum = {
  idle: "idle",
  loading: "loading",
  success: "success",
  error: "error",
}

export default StatusEnum
